import { render, staticRenderFns } from "./CallControlSection.vue?vue&type=template&id=ef2987cc&scoped=true"
import script from "./CallControlSection.vue?vue&type=script&lang=js"
export * from "./CallControlSection.vue?vue&type=script&lang=js"
import style0 from "./CallControlSection.vue?vue&type=style&index=0&id=ef2987cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2987cc",
  null
  
)

export default component.exports